export default (theItem) => {

    let theInitialItem = {
        id: theItem.id,
        extraItemDetails: "None",
        display_name: theItem.display_name,
        choice_id: theItem.id
    };

    if (theItem.custom_pizza_id) {
        theInitialItem.type = "custompizza";
        theInitialItem.max_toppings = theItem.pizza.max_toppings;
        theInitialItem.custom_pizza_id = theItem.custom_pizza_id;
        theInitialItem.toppings = [];

        // @TODO: review this to get the size in
        theInitialItem.name = theItem.pizza.max_toppings+" Topping Pizza";

        // add the custom crust (if necessary)
        if (theItem.crusts.length > 1) {

            // update with the selected crust
            theInitialItem.crust_id = theItem.crusts[0].id;
            theInitialItem.crust_name = theItem.crusts[0].name;
        }

        // // add the custom sauce (if necessary)
        if (theItem.sauces.length > 1) {

            // update with the selected sauce
            theInitialItem.sauce_id = theItem.sauces[0].id;
            theInitialItem.sauce_name = theItem.sauces[0].name;
        }
    }
    else if (theItem.pizza_id) {

        // it's a pizza
        theInitialItem.type = "pizza";
        theInitialItem.pizza_id = theItem.pizza_id;
        theInitialItem.toppings = [];

        // @TODO: review this to get the size in
        theInitialItem.name = theItem.pizza.name;

        // build out the toppings
        theItem.toppings.forEach((theTopping) => {
            if (theTopping.isdefault) {

                // default topping, add to the order pizza
                theInitialItem.toppings.push({
                    isdefault: true,
                    id: theTopping.id,
                    amount: "include",
                    portion: "W"
                });
            }
        });

        // add the custom crust (if necessary)
        if (theItem.crusts.length > 1) {

            // update with the selected crust
            theInitialItem.crust_id = theItem.crusts[0].id;
            theInitialItem.crust_name = theItem.crusts[0].name;
        }

        // // add the custom sauce (if necessary)
        if (theItem.sauces.length > 1) {

            // update with the selected sauce
            theInitialItem.sauce_id = theItem.sauces[0].id;
            theInitialItem.sauce_name = theItem.sauces[0].name;
        }
    }
    else if (theItem.beverage_id) {

        // it's a beverage
        theInitialItem.type = "beverage";
        theInitialItem.beverage_id = theItem.beverage_id;

        // @TODO: review this to get the size in
        theInitialItem.name = theItem.beverage.name;
    }
    else if (theItem.food_item_id) {

        // it's a food item
        theInitialItem.type = "fooditem";
        theInitialItem.food_item_id = theItem.food_item_id;
        theInitialItem.choices = [];
        theInitialItem.addons = [];

        // @TODO: review this to get the size in
        theInitialItem.name = theItem.fooditem.name;

        theItem.fooditem.choices.forEach((theChoice) => {
            let choice = {
                id: theChoice.id,
                name: theChoice.name
            };

            if (theChoice.is_multiple == 1) {
                choice.is_multiple = 1;
                choice.max_choices = theChoice.max_choices;
                choice.items = [];
                choice.item_name = 'No Items selected.';
                choice.item_price = 0.00;
            }
            else {
                choice.is_multiple = 0;
                choice.item_id = theChoice.selections[0].id;
                choice.item_name = theChoice.selections[0].name;
                choice.item_price = theChoice.selections[0].price;
            }
            theInitialItem.choices.push(choice);                    
        });
    }

    return theInitialItem;
};